import { gql } from '@apollo/client'

export const SWITCH_COACH = gql`
  mutation switchCoach(
    $coachIdToSwitchTo: ID!
    $appointmentKind: EhrAppointmentKind
    $selectedSlot: String
    $recurring: Boolean
    $appointmentIdsToReschedule: [ID!]
    $appointmentIdsToCancel: [ID!]
  ) {
    switchCoach(
      coachIdToSwitchTo: $coachIdToSwitchTo
      appointmentKind: $appointmentKind
      selectedSlot: $selectedSlot
      recurring: $recurring
      appointmentIdsToReschedule: $appointmentIdsToReschedule
      appointmentIdsToCancel: $appointmentIdsToCancel
    ) {
      success
    }
  }
`
